// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/lg.eot?n1z373", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/lg.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/lg.woff?n1z373", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/lg.ttf?n1z373", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/lg.svg?n1z373", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/vimeo-play.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/video-play.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/youtube-play.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/loading.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefixn1z373" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#lg" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! lightgallery - v1.2.18 - 2016-04-13
* http://sachinchoolur.github.io/lightGallery/
* Copyright (c) 2016 Sachin N; Licensed Apache 2.0 */
@font-face {
    font-family: 'lg';
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
}

.lg-icon {
    -moz-osx-font-smoothing: grayscale;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    font-family: 'lg';
    font-style: normal;
    font-variant: normal;
    font-weight: normal;
    line-height: 1;
    speak: none;
    text-transform: none;
}

.lg-actions .lg-next, .lg-actions .lg-prev {
    background-color: rgba(0, 0, 0, 0.45);
    border-radius: 2px;
    color: #999;
    cursor: pointer;
    display: block;
    font-size: 22px;
    margin-top: -10px;
    padding: 8px 10px 9px;
    position: absolute;
    top: 50%;
    z-index: 1080;
}

.lg-actions .lg-next.disabled, .lg-actions .lg-prev.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.lg-actions .lg-next:hover, .lg-actions .lg-prev:hover { color: #FFF; }

.lg-actions .lg-next { right: 20px; }

.lg-actions .lg-next:before { content: "\\e095"; }

.lg-actions .lg-prev { left: 20px; }

.lg-actions .lg-prev:after { content: "\\e094"; }

@-webkit-keyframes lg-right-end {
    0% { left: 0; }

    50% { left: -30px; }

    100% { left: 0; }
}

@-moz-keyframes lg-right-end {
    0% { left: 0; }

    50% { left: -30px; }

    100% { left: 0; }
}

@-ms-keyframes lg-right-end {
    0% { left: 0; }

    50% { left: -30px; }

    100% { left: 0; }
}

@keyframes lg-right-end {
    0% { left: 0; }

    50% { left: -30px; }

    100% { left: 0; }
}

@-webkit-keyframes lg-left-end {
    0% { left: 0; }

    50% { left: 30px; }

    100% { left: 0; }
}

@-moz-keyframes lg-left-end {
    0% { left: 0; }

    50% { left: 30px; }

    100% { left: 0; }
}

@-ms-keyframes lg-left-end {
    0% { left: 0; }

    50% { left: 30px; }

    100% { left: 0; }
}

@keyframes lg-left-end {
    0% { left: 0; }

    50% { left: 30px; }

    100% { left: 0; }
}

.lg-outer.lg-right-end .lg-object {
    -o-animation: lg-right-end 0.3s;
    -webkit-animation: lg-right-end 0.3s;
    animation: lg-right-end 0.3s;
    position: relative;
}

.lg-outer.lg-left-end .lg-object {
    -o-animation: lg-left-end 0.3s;
    -webkit-animation: lg-left-end 0.3s;
    animation: lg-left-end 0.3s;
    position: relative;
}

.lg-toolbar {
    background-color: rgba(0, 0, 0, 0.45);
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1080;
}

.lg-toolbar .lg-icon {
    color: #999;
    cursor: pointer;
    float: right;
    font-size: 24px;
    height: 47px;
    line-height: 27px;
    outline: medium none;
    padding: 10px 0;
    text-align: center;
    text-decoration: none !important;
    width: 50px;
}

.lg-toolbar .lg-icon:hover { color: #FFF; }

.lg-toolbar .lg-close:after { content: "\\e070"; }

.lg-toolbar .lg-download:after { content: "\\e0f2"; }

.lg-sub-html {
    background-color: rgba(0, 0, 0, 0.45);
    bottom: 0;
    color: #EEE;
    font-size: 16px;
    left: 0;
    opacity: 0.9;
    padding: 10px 40px;
    position: fixed;
    right: 0;
    text-align: center;
    z-index: 1080;
}

.lg-sub-html h4 {
    font-size: 13px;
    font-weight: bold;
    margin: 0;
}

.lg-sub-html p {
    font-size: 12px;
    margin: 5px 0 0;
}

#lg-counter {
    color: #999;
    display: inline-block;
    font-size: 16px;
    padding-left: 20px;
    padding-top: 12px;
    vertical-align: middle;
}

.lg-toolbar, .lg-prev, .lg-next {
    -moz-transition: -moz-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;
    -o-transition: -o-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;
    -webkit-transition: -webkit-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;
    opacity: 1;
    transition: transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;
}

.lg-hide-items .lg-prev {
    -webkit-transform: translate3d(-10px, 0, 0);
    opacity: 0;
    transform: translate3d(-10px, 0, 0);
}

.lg-hide-items .lg-next {
    -webkit-transform: translate3d(10px, 0, 0);
    opacity: 0;
    transform: translate3d(10px, 0, 0);
}

.lg-hide-items .lg-toolbar {
    -webkit-transform: translate3d(0, -10px, 0);
    opacity: 0;
    transform: translate3d(0, -10px, 0);
}

body:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-object {
    -moz-transform-origin: 50% 50%;
    -moz-transition: -moz-transform 250ms ease 0s, opacity 250ms !important;
    -ms-transform-origin: 50% 50%;
    -o-transition: -o-transform 250ms ease 0s, opacity 250ms !important;
    -webkit-transform: scale3d(0.5, 0.5, 0.5);
    -webkit-transform-origin: 50% 50%;
    -webkit-transition: -webkit-transform 250ms ease 0s, opacity 250ms !important;
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
    transform-origin: 50% 50%;
    transition: transform 250ms ease 0s, opacity 250ms !important;
}

body:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-item.lg-complete .lg-object {
    -webkit-transform: scale3d(1, 1, 1);
    opacity: 1;
    transform: scale3d(1, 1, 1);
}

.lg-outer .lg-thumb-outer {
    -moz-transition: -moz-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;
    -o-transition: -o-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;
    -webkit-transform: translate3d(0, 100%, 0);
    -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;
    background-color: #0D0A0A;
    bottom: 0;
    max-height: 350px;
    position: absolute;
    transform: translate3d(0, 100%, 0);
    transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;
    width: 100%;
    z-index: 1080;
}

.lg-outer .lg-thumb-outer.lg-grab .lg-thumb-item {
    cursor: -webkit-grab;
    cursor: -moz-grab;
    cursor: -o-grab;
    cursor: -ms-grab;
    cursor: grab;
}

.lg-outer .lg-thumb-outer.lg-grabbing .lg-thumb-item {
    cursor: move;
    cursor: -webkit-grabbing;
    cursor: -moz-grabbing;
    cursor: -o-grabbing;
    cursor: -ms-grabbing;
    cursor: grabbing;
}

.lg-outer .lg-thumb-outer.lg-dragging .lg-thumb {
    -webkit-transition-duration: 0s !important;
    transition-duration: 0s !important;
}

.lg-outer.lg-thumb-open .lg-thumb-outer {
    -webkit-transform: translate3d(0, 0%, 0);
    transform: translate3d(0, 0%, 0);
}

.lg-outer .lg-thumb {
    height: 100%;
    margin-bottom: -5px;
    padding: 10px 0;
}

.lg-outer .lg-thumb-item {
    border: 2px solid #FFF;
    border-radius: 5px;
    border-radius: 4px;
    cursor: pointer;
    float: left;
    height: 100%;
    margin-bottom: 5px;
    overflow: hidden;
}

@media (min-width: 1025px) {
    .lg-outer .lg-thumb-item {
        -o-transition: border-color 0.25s ease;
        -webkit-transition: border-color 0.25s ease;
        transition: border-color 0.25s ease;
    }
}

.lg-outer .lg-thumb-item.active, .lg-outer .lg-thumb-item:hover { border-color: #a90707; }

.lg-outer .lg-thumb-item img {
    height: 100%;
    width: 100%;
}

.lg-outer.lg-has-thumb .lg-item { padding-bottom: 120px; }

.lg-outer.lg-can-toggle .lg-item { padding-bottom: 0; }

.lg-outer.lg-pull-caption-up .lg-sub-html {
    -o-transition: bottom 0.25s ease;
    -webkit-transition: bottom 0.25s ease;
    transition: bottom 0.25s ease;
}

.lg-outer.lg-pull-caption-up.lg-thumb-open .lg-sub-html { bottom: 100px; }

.lg-outer .lg-toogle-thumb {
    background-color: #0D0A0A;
    border-radius: 2px 2px 0 0;
    color: #999;
    cursor: pointer;
    font-size: 24px;
    height: 39px;
    line-height: 27px;
    padding: 5px 0;
    position: absolute;
    right: 20px;
    text-align: center;
    top: -39px;
    width: 50px;
}

.lg-outer .lg-toogle-thumb:after { content: "\\e1ff"; }

.lg-outer .lg-toogle-thumb:hover { color: #FFF; }

.lg-outer .lg-video-cont {
    display: inline-block;
    max-height: 100%;
    max-width: 1140px;
    padding: 0 5px;
    vertical-align: middle;
    width: 100%;
}

.lg-outer .lg-video {
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    width: 100%;
}

.lg-outer .lg-video .lg-object {
    display: inline-block;
    height: 100% !important;
    left: 0;
    position: absolute;
    top: 0;
    width: 100% !important;
}

.lg-outer .lg-video .lg-video-play {
    cursor: pointer;
    height: 59px;
    left: 50%;
    margin-left: -42px;
    margin-top: -30px;
    position: absolute;
    top: 50%;
    width: 84px;
    z-index: 1080;
}

.lg-outer .lg-has-vimeo .lg-video-play { background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat scroll 0 0 transparent; }

.lg-outer .lg-has-vimeo:hover .lg-video-play { background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat scroll 0 -58px transparent; }

.lg-outer .lg-has-html5 .lg-video-play {
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat scroll 0 0;
    height: 64px;
    margin-left: -32px;
    margin-top: -32px;
    opacity: 0.8;
    width: 64px;
}

.lg-outer .lg-has-html5:hover .lg-video-play { opacity: 1; }

.lg-outer .lg-has-youtube .lg-video-play { background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat scroll 0 0 transparent; }

.lg-outer .lg-has-youtube:hover .lg-video-play { background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat scroll 0 -60px transparent; }

.lg-outer .lg-video-object {
    height: 100% !important;
    left: 0;
    position: absolute;
    top: 0;
    width: 100% !important;
}

.lg-outer .lg-has-video .lg-video-object { visibility: hidden; }

.lg-outer .lg-has-video.lg-video-playing .lg-object, .lg-outer .lg-has-video.lg-video-playing .lg-video-play { display: none; }

.lg-outer .lg-has-video.lg-video-playing .lg-video-object { visibility: visible; }

.lg-progress-bar {
    -moz-transition: opacity 0.08s ease 0s;
    -o-transition: opacity 0.08s ease 0s;
    -webkit-transition: opacity 0.08s ease 0s;
    background-color: #333;
    height: 5px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity 0.08s ease 0s;
    width: 100%;
    z-index: 1080;
}

.lg-progress-bar .lg-progress {
    background-color: #a90707;
    height: 5px;
    width: 0;
}

.lg-progress-bar.lg-start .lg-progress { width: 100%; }

.lg-show-autoplay .lg-progress-bar { opacity: 1; }

.lg-autoplay-button:after { content: "\\e01d"; }

.lg-show-autoplay .lg-autoplay-button:after { content: "\\e01a"; }

.lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-img-wrap, .lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-image {
    -webkit-transition-duration: 0s;
    transition-duration: 0s;
}

.lg-outer .lg-item.lg-complete.lg-zoomable .lg-img-wrap {
    -moz-backface-visibility: hidden;
    -moz-transition: -moz-transform 0.3s ease 0s;
    -o-transition: -o-transform 0.3s ease 0s;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-transition: -webkit-transform 0.3s ease 0s;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    transition: transform 0.3s ease 0s;
}

.lg-outer .lg-item.lg-complete.lg-zoomable .lg-image {
    -moz-backface-visibility: hidden;
    -moz-transform-origin: 0 0;
    -moz-transition: -moz-transform 0.3s ease 0s, opacity 0.15s !important;
    -ms-transform-origin: 0 0;
    -o-transition: -o-transform 0.3s ease 0s, opacity 0.15s !important;
    -webkit-backface-visibility: hidden;
    -webkit-transform: scale3d(1, 1, 1);
    -webkit-transform-origin: 0 0;
    -webkit-transition: -webkit-transform 0.3s ease 0s, opacity 0.15s !important;
    backface-visibility: hidden;
    transform: scale3d(1, 1, 1);
    transform-origin: 0 0;
    transition: transform 0.3s ease 0s, opacity 0.15s !important;
}

#lg-zoom-in:after { content: "\\e311"; }

#lg-actual-size { font-size: 20px; }

#lg-actual-size:after { content: "\\e033"; }

#lg-zoom-out {
    opacity: 0.5;
    pointer-events: none;
}

#lg-zoom-out:after { content: "\\e312"; }

.lg-zoomed #lg-zoom-out {
    opacity: 1;
    pointer-events: auto;
}

.lg-outer .lg-pager-outer {
    bottom: 60px;
    height: 10px;
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;
    z-index: 1080;
}

.lg-outer .lg-pager-outer.lg-pager-hover .lg-pager-cont { overflow: visible; }

.lg-outer .lg-pager-cont {
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
    overflow: hidden;
    position: relative;
    vertical-align: top;
}

.lg-outer .lg-pager-cont:hover .lg-pager-thumb-cont {
    -webkit-transform: translate3d(0, 0, 0);
    opacity: 1;
    transform: translate3d(0, 0, 0);
}

.lg-outer .lg-pager-cont.lg-pager-active .lg-pager { box-shadow: 0 0 0 2px white inset; }

.lg-outer .lg-pager-thumb-cont {
    -moz-transition: opacity 0.15s ease 0s, -moz-transform 0.15s ease 0s;
    -o-transition: opacity 0.15s ease 0s, -o-transform 0.15s ease 0s;
    -webkit-transform: translate3d(0, 5px, 0);
    -webkit-transition: opacity 0.15s ease 0s, -webkit-transform 0.15s ease 0s;
    background-color: #fff;
    border-radius: 3px;
    bottom: 100%;
    color: #FFF;
    height: 83px;
    left: 0;
    margin-bottom: 20px;
    margin-left: -60px;
    opacity: 0;
    padding: 5px;
    position: absolute;
    transform: translate3d(0, 5px, 0);
    transition: opacity 0.15s ease 0s, transform 0.15s ease 0s;
    width: 120px;
}

.lg-outer .lg-pager-thumb-cont img {
    height: 100%;
    width: 100%;
}

.lg-outer .lg-pager {
    -o-transition: box-shadow 0.3s ease 0s;
    -webkit-transition: box-shadow 0.3s ease 0s;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.7) inset;
    display: block;
    height: 12px;
    transition: box-shadow 0.3s ease 0s;
    width: 12px;
}

.lg-outer .lg-pager:hover, .lg-outer .lg-pager:focus { box-shadow: 0 0 0 8px white inset; }

.lg-outer .lg-caret {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px dashed;
    bottom: -10px;
    display: inline-block;
    height: 0;
    left: 50%;
    margin-left: -5px;
    position: absolute;
    vertical-align: middle;
    width: 0;
}

.lg-fullscreen:after { content: "\\e20c"; }

.lg-fullscreen-on .lg-fullscreen:after { content: "\\e20d"; }

.group { *zoom: 1; }

.group:before, .group:after {
    content: "";
    display: table;
    line-height: 0;
}

.group:after { clear: both; }

.lg-outer {
    -o-transition: opacity 0.15s ease 0s;
    -webkit-transition: opacity 0.15s ease 0s;
    height: 100%;
    left: 0;
    opacity: 0;
    position: fixed;
    top: 0;
    transition: opacity 0.15s ease 0s;
    width: 100%;
    z-index: 1050;
}

.lg-outer * {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.lg-outer.lg-visible { opacity: 1; }

.lg-outer.lg-css3 .lg-item.lg-prev-slide, .lg-outer.lg-css3 .lg-item.lg-next-slide, .lg-outer.lg-css3 .lg-item.lg-current {
    -webkit-transition-duration: inherit !important;
    -webkit-transition-timing-function: inherit !important;
    transition-duration: inherit !important;
    transition-timing-function: inherit !important;
}

.lg-outer.lg-css3.lg-dragging .lg-item.lg-prev-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-next-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-current {
    -webkit-transition-duration: 0s !important;
    opacity: 1;
    transition-duration: 0s !important;
}

.lg-outer.lg-grab img.lg-object {
    cursor: -webkit-grab;
    cursor: -moz-grab;
    cursor: -o-grab;
    cursor: -ms-grab;
    cursor: grab;
}

.lg-outer.lg-grabbing img.lg-object {
    cursor: move;
    cursor: -webkit-grabbing;
    cursor: -moz-grabbing;
    cursor: -o-grabbing;
    cursor: -ms-grabbing;
    cursor: grabbing;
}

.lg-outer .lg {
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    position: relative;
    width: 100%;
}

.lg-outer .lg-inner {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    white-space: nowrap;
    width: 100%;
}

.lg-outer .lg-item {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat scroll center center transparent;
    display: none !important;
}

.lg-outer.lg-css3 .lg-prev-slide, .lg-outer.lg-css3 .lg-current, .lg-outer.lg-css3 .lg-next-slide { display: inline-block !important; }

.lg-outer.lg-css .lg-current { display: inline-block !important; }

.lg-outer .lg-item, .lg-outer .lg-img-wrap {
    display: inline-block;
    height: 100%;
    position: absolute;
    text-align: center;
    width: 100%;
}

.lg-outer .lg-item:before, .lg-outer .lg-img-wrap:before {
    content: "";
    display: inline-block;
    height: 50%;
    margin-right: -1px;
    width: 1px;
}

.lg-outer .lg-img-wrap {
    padding: 0 5px;
    position: static;
}

.lg-outer .lg-item.lg-complete { background-image: none; }

.lg-outer .lg-item.lg-current { z-index: 1060; }

.lg-outer .lg-image {
    display: inline-block;
    height: auto !important;
    max-height: 100%;
    max-width: 100%;
    vertical-align: middle;
    width: auto !important;
}

.lg-outer.lg-show-after-load .lg-item .lg-object, .lg-outer.lg-show-after-load .lg-item .lg-video-play {
    -o-transition: opacity 0.15s ease 0s;
    -webkit-transition: opacity 0.15s ease 0s;
    opacity: 0;
    transition: opacity 0.15s ease 0s;
}

.lg-outer.lg-show-after-load .lg-item.lg-complete .lg-object, .lg-outer.lg-show-after-load .lg-item.lg-complete .lg-video-play { opacity: 1; }

.lg-outer .lg-empty-html { display: none; }

.lg-outer.lg-hide-download #lg-download { display: none; }

.lg-backdrop {
    -o-transition: opacity 0.15s ease 0s;
    -webkit-transition: opacity 0.15s ease 0s;
    background-color: #000;
    bottom: 0;
    left: 0;
    opacity: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 0.15s ease 0s;
    z-index: 1040;
}

.lg-backdrop.in { opacity: 0.7; }

.lg-css3.lg-no-trans .lg-prev-slide, .lg-css3.lg-no-trans .lg-next-slide, .lg-css3.lg-no-trans .lg-current {
    -moz-transition: none 0s ease 0s !important;
    -o-transition: none 0s ease 0s !important;
    -webkit-transition: none 0s ease 0s !important;
    transition: none 0s ease 0s !important;
}

.lg-css3.lg-use-css3 .lg-item {
    -moz-backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.lg-css3.lg-use-left .lg-item {
    -moz-backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.lg-css3.lg-fade .lg-item { opacity: 0; }

.lg-css3.lg-fade .lg-item.lg-current { opacity: 1; }

.lg-css3.lg-fade .lg-item.lg-prev-slide, .lg-css3.lg-fade .lg-item.lg-next-slide, .lg-css3.lg-fade .lg-item.lg-current {
    -moz-transition: opacity 0.1s ease 0s;
    -o-transition: opacity 0.1s ease 0s;
    -webkit-transition: opacity 0.1s ease 0s;
    transition: opacity 0.1s ease 0s;
}

.lg-css3.lg-slide.lg-use-css3 .lg-item { opacity: 0; }

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {
    -webkit-transform: translate3d(0, 0, 0);
    opacity: 1;
    transform: translate3d(0, 0, 0);
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {
    -moz-transition: -moz-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
    -o-transition: -o-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
    -webkit-transition: -webkit-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
    transition: transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
}

.lg-css3.lg-slide.lg-use-left .lg-item {
    left: 0;
    opacity: 0;
    position: absolute;
}

.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide { left: -100%; }

.lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide { left: 100%; }

.lg-css3.lg-slide.lg-use-left .lg-item.lg-current {
    left: 0;
    opacity: 1;
}

.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-current {
    -moz-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
    -o-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
    -webkit-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
    transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
}

/*# sourceMappingURL=lightgallery.css.map */`, "",{"version":3,"sources":["webpack://./assets/lightGallery/css/lightgallery.css"],"names":[],"mappings":"AAAA;;oDAEoD;AACpD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,4CAAkC;IAClC,mPAAqN;AACzN;;AAEA;IACI,kCAAkC;IAClC,sCAAsC;IACtC,mCAAmC;IACnC,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA,yDAAyD,WAAW,EAAE;;AAEtE,uBAAuB,WAAW,EAAE;;AAEpC,8BAA8B,gBAAgB,EAAE;;AAEhD,uBAAuB,UAAU,EAAE;;AAEnC,6BAA6B,gBAAgB,EAAE;;AAE/C;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,WAAW,EAAE;;IAEnB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,WAAW,EAAE;;IAEnB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,WAAW,EAAE;;IAEnB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,WAAW,EAAE;;IAEnB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,UAAU,EAAE;;IAElB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,UAAU,EAAE;;IAElB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,UAAU,EAAE;;IAElB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,KAAK,OAAO,EAAE;;IAEd,MAAM,UAAU,EAAE;;IAElB,OAAO,OAAO,EAAE;AACpB;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;AACf;;AAEA,6BAA6B,WAAW,EAAE;;AAE1C,8BAA8B,gBAAgB,EAAE;;AAEhD,iCAAiC,gBAAgB,EAAE;;AAEnD;IACI,qCAAqC;IACrC,SAAS;IACT,WAAW;IACX,eAAe;IACf,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kHAAkH;IAClH,8GAA8G;IAC9G,wHAAwH;IACxH,UAAU;IACV,wGAAwG;AAC5G;;AAEA;IACI,2CAA2C;IAC3C,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,UAAU;IACV,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,uEAAuE;IACvE,6BAA6B;IAC7B,mEAAmE;IACnE,yCAAyC;IACzC,iCAAiC;IACjC,6EAA6E;IAC7E,UAAU;IACV,iCAAiC;IACjC,yBAAyB;IACzB,6DAA6D;AACjE;;AAEA;IACI,mCAAmC;IACnC,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,oEAAoE;IACpE,gEAAgE;IAChE,0CAA0C;IAC1C,0EAA0E;IAC1E,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,0DAA0D;IAC1D,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,sCAAsC;QACtC,2CAA2C;QAC3C,mCAAmC;IACvC;AACJ;;AAEA,kEAAkE,qBAAqB,EAAE;;AAEzF;IACI,YAAY;IACZ,WAAW;AACf;;AAEA,kCAAkC,qBAAqB,EAAE;;AAEzD,mCAAmC,iBAAiB,EAAE;;AAEtD;IACI,gCAAgC;IAChC,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA,0DAA0D,aAAa,EAAE;;AAEzE;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA,mCAAmC,gBAAgB,EAAE;;AAErD,mCAAmC,WAAW,EAAE;;AAEhD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,aAAa;AACjB;;AAEA,yCAAyC,oFAAyE,EAAE;;AAEpH,+CAA+C,wFAA6E,EAAE;;AAE9H;IACI,oFAAyE;IACzE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA,+CAA+C,UAAU,EAAE;;AAE3D,2CAA2C,oFAA2E,EAAE;;AAExH,iDAAiD,wFAA+E,EAAE;;AAElI;IACI,uBAAuB;IACvB,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,sBAAsB;AAC1B;;AAEA,2CAA2C,kBAAkB,EAAE;;AAE/D,+GAA+G,aAAa,EAAE;;AAE9H,4DAA4D,mBAAmB,EAAE;;AAEjF;IACI,sCAAsC;IACtC,oCAAoC;IACpC,yCAAyC;IACzC,sBAAsB;IACtB,WAAW;IACX,OAAO;IACP,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,iCAAiC;IACjC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,QAAQ;AACZ;;AAEA,yCAAyC,WAAW,EAAE;;AAEtD,qCAAqC,UAAU,EAAE;;AAEjD,4BAA4B,gBAAgB,EAAE;;AAE9C,8CAA8C,gBAAgB,EAAE;;AAEhE;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,wCAAwC;IACxC,mCAAmC;IACnC,uCAAuC;IACvC,kDAAkD;IAClD,2BAA2B;IAC3B,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,sEAAsE;IACtE,yBAAyB;IACzB,kEAAkE;IAClE,mCAAmC;IACnC,mCAAmC;IACnC,6BAA6B;IAC7B,4EAA4E;IAC5E,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;IACrB,4DAA4D;AAChE;;AAEA,oBAAoB,gBAAgB,EAAE;;AAEtC,kBAAkB,eAAe,EAAE;;AAEnC,wBAAwB,gBAAgB,EAAE;;AAE1C;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA,qBAAqB,gBAAgB,EAAE;;AAEvC;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,aAAa;AACjB;;AAEA,0DAA0D,iBAAiB,EAAE;;AAE7E;IACI,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,UAAU;IACV,+BAA+B;AACnC;;AAEA,qDAAqD,iCAAiC,EAAE;;AAExF;IACI,oEAAoE;IACpE,gEAAgE;IAChE,yCAAyC;IACzC,0EAA0E;IAC1E,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,OAAO;IACP,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,0DAA0D;IAC1D,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,oDAAoD;IACpD,cAAc;IACd,YAAY;IACZ,mCAAmC;IACnC,WAAW;AACf;;AAEA,uDAAuD,iCAAiC,EAAE;;AAE1F;IACI,mCAAmC;IACnC,oCAAoC;IACpC,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,uBAAuB,gBAAgB,EAAE;;AAEzC,yCAAyC,gBAAgB,EAAE;;AAE3D,UAAS,OAAQ,EAAE;;AAEnB;IACI,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA,eAAe,WAAW,EAAE;;AAE5B;IACI,oCAAoC;IACpC,yCAAyC;IACzC,YAAY;IACZ,OAAO;IACP,UAAU;IACV,eAAe;IACf,MAAM;IACN,iCAAiC;IACjC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA,uBAAuB,UAAU,EAAE;;AAEnC;IACI,+CAA+C;IAC/C,sDAAsD;IACtD,uCAAuC;IACvC,8CAA8C;AAClD;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,8FAAgF;IAChF,wBAAwB;AAC5B;;AAEA,oGAAoG,gCAAgC,EAAE;;AAEtI,+BAA+B,gCAAgC,EAAE;;AAEjE;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,iCAAiC,sBAAsB,EAAE;;AAEzD,gCAAgC,aAAa,EAAE;;AAE/C;IACI,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,UAAU;IACV,iCAAiC;AACrC;;AAEA,iIAAiI,UAAU,EAAE;;AAE7I,2BAA2B,aAAa,EAAE;;AAE1C,0CAA0C,aAAa,EAAE;;AAEzD;IACI,oCAAoC;IACpC,yCAAyC;IACzC,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,UAAU;IACV,eAAe;IACf,QAAQ;IACR,MAAM;IACN,iCAAiC;IACjC,aAAa;AACjB;;AAEA,kBAAkB,YAAY,EAAE;;AAEhC;IACI,2CAA2C;IAC3C,yCAAyC;IACzC,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA,4BAA4B,UAAU,EAAE;;AAExC,uCAAuC,UAAU,EAAE;;AAEnD;IACI,qCAAqC;IACrC,mCAAmC;IACnC,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA,yCAAyC,UAAU,EAAE;;AAErD;IACI,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,uFAAuF;IACvF,mFAAmF;IACnF,6FAA6F;IAC7F,6EAA6E;AACjF;;AAEA;IACI,OAAO;IACP,UAAU;IACV,kBAAkB;AACtB;;AAEA,uDAAuD,WAAW,EAAE;;AAEpE,uDAAuD,UAAU,EAAE;;AAEnE;IACI,OAAO;IACP,UAAU;AACd;;AAEA;IACI,6EAA6E;IAC7E,2EAA2E;IAC3E,gFAAgF;IAChF,wEAAwE;AAC5E;;AAEA,2CAA2C","sourcesContent":["/*! lightgallery - v1.2.18 - 2016-04-13\r\n* http://sachinchoolur.github.io/lightGallery/\r\n* Copyright (c) 2016 Sachin N; Licensed Apache 2.0 */\r\n@font-face {\r\n    font-family: 'lg';\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    src: url(\"../fonts/lg.eot?n1z373\");\r\n    src: url(\"../fonts/lg.eot?#iefixn1z373\") format(\"embedded-opentype\"), url(\"../fonts/lg.woff?n1z373\") format(\"woff\"), url(\"../fonts/lg.ttf?n1z373\") format(\"truetype\"), url(\"../fonts/lg.svg?n1z373#lg\") format(\"svg\");\r\n}\r\n\r\n.lg-icon {\r\n    -moz-osx-font-smoothing: grayscale;\r\n    /* Better Font Rendering =========== */\r\n    -webkit-font-smoothing: antialiased;\r\n    font-family: 'lg';\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    font-weight: normal;\r\n    line-height: 1;\r\n    speak: none;\r\n    text-transform: none;\r\n}\r\n\r\n.lg-actions .lg-next, .lg-actions .lg-prev {\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    border-radius: 2px;\r\n    color: #999;\r\n    cursor: pointer;\r\n    display: block;\r\n    font-size: 22px;\r\n    margin-top: -10px;\r\n    padding: 8px 10px 9px;\r\n    position: absolute;\r\n    top: 50%;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-actions .lg-next.disabled, .lg-actions .lg-prev.disabled {\r\n    opacity: 0.5;\r\n    pointer-events: none;\r\n}\r\n\r\n.lg-actions .lg-next:hover, .lg-actions .lg-prev:hover { color: #FFF; }\r\n\r\n.lg-actions .lg-next { right: 20px; }\r\n\r\n.lg-actions .lg-next:before { content: \"\\e095\"; }\r\n\r\n.lg-actions .lg-prev { left: 20px; }\r\n\r\n.lg-actions .lg-prev:after { content: \"\\e094\"; }\r\n\r\n@-webkit-keyframes lg-right-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: -30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@-moz-keyframes lg-right-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: -30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@-ms-keyframes lg-right-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: -30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@keyframes lg-right-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: -30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@-webkit-keyframes lg-left-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: 30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@-moz-keyframes lg-left-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: 30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@-ms-keyframes lg-left-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: 30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n@keyframes lg-left-end {\r\n    0% { left: 0; }\r\n\r\n    50% { left: 30px; }\r\n\r\n    100% { left: 0; }\r\n}\r\n\r\n.lg-outer.lg-right-end .lg-object {\r\n    -o-animation: lg-right-end 0.3s;\r\n    -webkit-animation: lg-right-end 0.3s;\r\n    animation: lg-right-end 0.3s;\r\n    position: relative;\r\n}\r\n\r\n.lg-outer.lg-left-end .lg-object {\r\n    -o-animation: lg-left-end 0.3s;\r\n    -webkit-animation: lg-left-end 0.3s;\r\n    animation: lg-left-end 0.3s;\r\n    position: relative;\r\n}\r\n\r\n.lg-toolbar {\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-toolbar .lg-icon {\r\n    color: #999;\r\n    cursor: pointer;\r\n    float: right;\r\n    font-size: 24px;\r\n    height: 47px;\r\n    line-height: 27px;\r\n    outline: medium none;\r\n    padding: 10px 0;\r\n    text-align: center;\r\n    text-decoration: none !important;\r\n    width: 50px;\r\n}\r\n\r\n.lg-toolbar .lg-icon:hover { color: #FFF; }\r\n\r\n.lg-toolbar .lg-close:after { content: \"\\e070\"; }\r\n\r\n.lg-toolbar .lg-download:after { content: \"\\e0f2\"; }\r\n\r\n.lg-sub-html {\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    bottom: 0;\r\n    color: #EEE;\r\n    font-size: 16px;\r\n    left: 0;\r\n    opacity: 0.9;\r\n    padding: 10px 40px;\r\n    position: fixed;\r\n    right: 0;\r\n    text-align: center;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-sub-html h4 {\r\n    font-size: 13px;\r\n    font-weight: bold;\r\n    margin: 0;\r\n}\r\n\r\n.lg-sub-html p {\r\n    font-size: 12px;\r\n    margin: 5px 0 0;\r\n}\r\n\r\n#lg-counter {\r\n    color: #999;\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    padding-left: 20px;\r\n    padding-top: 12px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.lg-toolbar, .lg-prev, .lg-next {\r\n    -moz-transition: -moz-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    -o-transition: -o-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    -webkit-transition: -webkit-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    opacity: 1;\r\n    transition: transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n}\r\n\r\n.lg-hide-items .lg-prev {\r\n    -webkit-transform: translate3d(-10px, 0, 0);\r\n    opacity: 0;\r\n    transform: translate3d(-10px, 0, 0);\r\n}\r\n\r\n.lg-hide-items .lg-next {\r\n    -webkit-transform: translate3d(10px, 0, 0);\r\n    opacity: 0;\r\n    transform: translate3d(10px, 0, 0);\r\n}\r\n\r\n.lg-hide-items .lg-toolbar {\r\n    -webkit-transform: translate3d(0, -10px, 0);\r\n    opacity: 0;\r\n    transform: translate3d(0, -10px, 0);\r\n}\r\n\r\nbody:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-object {\r\n    -moz-transform-origin: 50% 50%;\r\n    -moz-transition: -moz-transform 250ms ease 0s, opacity 250ms !important;\r\n    -ms-transform-origin: 50% 50%;\r\n    -o-transition: -o-transform 250ms ease 0s, opacity 250ms !important;\r\n    -webkit-transform: scale3d(0.5, 0.5, 0.5);\r\n    -webkit-transform-origin: 50% 50%;\r\n    -webkit-transition: -webkit-transform 250ms ease 0s, opacity 250ms !important;\r\n    opacity: 0;\r\n    transform: scale3d(0.5, 0.5, 0.5);\r\n    transform-origin: 50% 50%;\r\n    transition: transform 250ms ease 0s, opacity 250ms !important;\r\n}\r\n\r\nbody:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-item.lg-complete .lg-object {\r\n    -webkit-transform: scale3d(1, 1, 1);\r\n    opacity: 1;\r\n    transform: scale3d(1, 1, 1);\r\n}\r\n\r\n.lg-outer .lg-thumb-outer {\r\n    -moz-transition: -moz-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    -o-transition: -o-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    -webkit-transform: translate3d(0, 100%, 0);\r\n    -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    background-color: #0D0A0A;\r\n    bottom: 0;\r\n    max-height: 350px;\r\n    position: absolute;\r\n    transform: translate3d(0, 100%, 0);\r\n    transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\r\n    width: 100%;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-outer .lg-thumb-outer.lg-grab .lg-thumb-item {\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n    cursor: -o-grab;\r\n    cursor: -ms-grab;\r\n    cursor: grab;\r\n}\r\n\r\n.lg-outer .lg-thumb-outer.lg-grabbing .lg-thumb-item {\r\n    cursor: move;\r\n    cursor: -webkit-grabbing;\r\n    cursor: -moz-grabbing;\r\n    cursor: -o-grabbing;\r\n    cursor: -ms-grabbing;\r\n    cursor: grabbing;\r\n}\r\n\r\n.lg-outer .lg-thumb-outer.lg-dragging .lg-thumb {\r\n    -webkit-transition-duration: 0s !important;\r\n    transition-duration: 0s !important;\r\n}\r\n\r\n.lg-outer.lg-thumb-open .lg-thumb-outer {\r\n    -webkit-transform: translate3d(0, 0%, 0);\r\n    transform: translate3d(0, 0%, 0);\r\n}\r\n\r\n.lg-outer .lg-thumb {\r\n    height: 100%;\r\n    margin-bottom: -5px;\r\n    padding: 10px 0;\r\n}\r\n\r\n.lg-outer .lg-thumb-item {\r\n    border: 2px solid #FFF;\r\n    border-radius: 5px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    float: left;\r\n    height: 100%;\r\n    margin-bottom: 5px;\r\n    overflow: hidden;\r\n}\r\n\r\n@media (min-width: 1025px) {\r\n    .lg-outer .lg-thumb-item {\r\n        -o-transition: border-color 0.25s ease;\r\n        -webkit-transition: border-color 0.25s ease;\r\n        transition: border-color 0.25s ease;\r\n    }\r\n}\r\n\r\n.lg-outer .lg-thumb-item.active, .lg-outer .lg-thumb-item:hover { border-color: #a90707; }\r\n\r\n.lg-outer .lg-thumb-item img {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer.lg-has-thumb .lg-item { padding-bottom: 120px; }\r\n\r\n.lg-outer.lg-can-toggle .lg-item { padding-bottom: 0; }\r\n\r\n.lg-outer.lg-pull-caption-up .lg-sub-html {\r\n    -o-transition: bottom 0.25s ease;\r\n    -webkit-transition: bottom 0.25s ease;\r\n    transition: bottom 0.25s ease;\r\n}\r\n\r\n.lg-outer.lg-pull-caption-up.lg-thumb-open .lg-sub-html { bottom: 100px; }\r\n\r\n.lg-outer .lg-toogle-thumb {\r\n    background-color: #0D0A0A;\r\n    border-radius: 2px 2px 0 0;\r\n    color: #999;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n    height: 39px;\r\n    line-height: 27px;\r\n    padding: 5px 0;\r\n    position: absolute;\r\n    right: 20px;\r\n    text-align: center;\r\n    top: -39px;\r\n    width: 50px;\r\n}\r\n\r\n.lg-outer .lg-toogle-thumb:after { content: \"\\e1ff\"; }\r\n\r\n.lg-outer .lg-toogle-thumb:hover { color: #FFF; }\r\n\r\n.lg-outer .lg-video-cont {\r\n    display: inline-block;\r\n    max-height: 100%;\r\n    max-width: 1140px;\r\n    padding: 0 5px;\r\n    vertical-align: middle;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer .lg-video {\r\n    height: 0;\r\n    overflow: hidden;\r\n    padding-bottom: 56.25%;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer .lg-video .lg-object {\r\n    display: inline-block;\r\n    height: 100% !important;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100% !important;\r\n}\r\n\r\n.lg-outer .lg-video .lg-video-play {\r\n    cursor: pointer;\r\n    height: 59px;\r\n    left: 50%;\r\n    margin-left: -42px;\r\n    margin-top: -30px;\r\n    position: absolute;\r\n    top: 50%;\r\n    width: 84px;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-outer .lg-has-vimeo .lg-video-play { background: url(\"../img/vimeo-play.png\") no-repeat scroll 0 0 transparent; }\r\n\r\n.lg-outer .lg-has-vimeo:hover .lg-video-play { background: url(\"../img/vimeo-play.png\") no-repeat scroll 0 -58px transparent; }\r\n\r\n.lg-outer .lg-has-html5 .lg-video-play {\r\n    background: transparent url(\"../img/video-play.png\") no-repeat scroll 0 0;\r\n    height: 64px;\r\n    margin-left: -32px;\r\n    margin-top: -32px;\r\n    opacity: 0.8;\r\n    width: 64px;\r\n}\r\n\r\n.lg-outer .lg-has-html5:hover .lg-video-play { opacity: 1; }\r\n\r\n.lg-outer .lg-has-youtube .lg-video-play { background: url(\"../img/youtube-play.png\") no-repeat scroll 0 0 transparent; }\r\n\r\n.lg-outer .lg-has-youtube:hover .lg-video-play { background: url(\"../img/youtube-play.png\") no-repeat scroll 0 -60px transparent; }\r\n\r\n.lg-outer .lg-video-object {\r\n    height: 100% !important;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 100% !important;\r\n}\r\n\r\n.lg-outer .lg-has-video .lg-video-object { visibility: hidden; }\r\n\r\n.lg-outer .lg-has-video.lg-video-playing .lg-object, .lg-outer .lg-has-video.lg-video-playing .lg-video-play { display: none; }\r\n\r\n.lg-outer .lg-has-video.lg-video-playing .lg-video-object { visibility: visible; }\r\n\r\n.lg-progress-bar {\r\n    -moz-transition: opacity 0.08s ease 0s;\r\n    -o-transition: opacity 0.08s ease 0s;\r\n    -webkit-transition: opacity 0.08s ease 0s;\r\n    background-color: #333;\r\n    height: 5px;\r\n    left: 0;\r\n    opacity: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    transition: opacity 0.08s ease 0s;\r\n    width: 100%;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-progress-bar .lg-progress {\r\n    background-color: #a90707;\r\n    height: 5px;\r\n    width: 0;\r\n}\r\n\r\n.lg-progress-bar.lg-start .lg-progress { width: 100%; }\r\n\r\n.lg-show-autoplay .lg-progress-bar { opacity: 1; }\r\n\r\n.lg-autoplay-button:after { content: \"\\e01d\"; }\r\n\r\n.lg-show-autoplay .lg-autoplay-button:after { content: \"\\e01a\"; }\r\n\r\n.lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-img-wrap, .lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-image {\r\n    -webkit-transition-duration: 0s;\r\n    transition-duration: 0s;\r\n}\r\n\r\n.lg-outer .lg-item.lg-complete.lg-zoomable .lg-img-wrap {\r\n    -moz-backface-visibility: hidden;\r\n    -moz-transition: -moz-transform 0.3s ease 0s;\r\n    -o-transition: -o-transform 0.3s ease 0s;\r\n    -webkit-backface-visibility: hidden;\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n    -webkit-transition: -webkit-transform 0.3s ease 0s;\r\n    backface-visibility: hidden;\r\n    transform: translate3d(0, 0, 0);\r\n    transition: transform 0.3s ease 0s;\r\n}\r\n\r\n.lg-outer .lg-item.lg-complete.lg-zoomable .lg-image {\r\n    -moz-backface-visibility: hidden;\r\n    -moz-transform-origin: 0 0;\r\n    -moz-transition: -moz-transform 0.3s ease 0s, opacity 0.15s !important;\r\n    -ms-transform-origin: 0 0;\r\n    -o-transition: -o-transform 0.3s ease 0s, opacity 0.15s !important;\r\n    -webkit-backface-visibility: hidden;\r\n    -webkit-transform: scale3d(1, 1, 1);\r\n    -webkit-transform-origin: 0 0;\r\n    -webkit-transition: -webkit-transform 0.3s ease 0s, opacity 0.15s !important;\r\n    backface-visibility: hidden;\r\n    transform: scale3d(1, 1, 1);\r\n    transform-origin: 0 0;\r\n    transition: transform 0.3s ease 0s, opacity 0.15s !important;\r\n}\r\n\r\n#lg-zoom-in:after { content: \"\\e311\"; }\r\n\r\n#lg-actual-size { font-size: 20px; }\r\n\r\n#lg-actual-size:after { content: \"\\e033\"; }\r\n\r\n#lg-zoom-out {\r\n    opacity: 0.5;\r\n    pointer-events: none;\r\n}\r\n\r\n#lg-zoom-out:after { content: \"\\e312\"; }\r\n\r\n.lg-zoomed #lg-zoom-out {\r\n    opacity: 1;\r\n    pointer-events: auto;\r\n}\r\n\r\n.lg-outer .lg-pager-outer {\r\n    bottom: 60px;\r\n    height: 10px;\r\n    left: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    text-align: center;\r\n    z-index: 1080;\r\n}\r\n\r\n.lg-outer .lg-pager-outer.lg-pager-hover .lg-pager-cont { overflow: visible; }\r\n\r\n.lg-outer .lg-pager-cont {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    margin: 0 5px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    vertical-align: top;\r\n}\r\n\r\n.lg-outer .lg-pager-cont:hover .lg-pager-thumb-cont {\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n}\r\n\r\n.lg-outer .lg-pager-cont.lg-pager-active .lg-pager { box-shadow: 0 0 0 2px white inset; }\r\n\r\n.lg-outer .lg-pager-thumb-cont {\r\n    -moz-transition: opacity 0.15s ease 0s, -moz-transform 0.15s ease 0s;\r\n    -o-transition: opacity 0.15s ease 0s, -o-transform 0.15s ease 0s;\r\n    -webkit-transform: translate3d(0, 5px, 0);\r\n    -webkit-transition: opacity 0.15s ease 0s, -webkit-transform 0.15s ease 0s;\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    bottom: 100%;\r\n    color: #FFF;\r\n    height: 83px;\r\n    left: 0;\r\n    margin-bottom: 20px;\r\n    margin-left: -60px;\r\n    opacity: 0;\r\n    padding: 5px;\r\n    position: absolute;\r\n    transform: translate3d(0, 5px, 0);\r\n    transition: opacity 0.15s ease 0s, transform 0.15s ease 0s;\r\n    width: 120px;\r\n}\r\n\r\n.lg-outer .lg-pager-thumb-cont img {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer .lg-pager {\r\n    -o-transition: box-shadow 0.3s ease 0s;\r\n    -webkit-transition: box-shadow 0.3s ease 0s;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n    border-radius: 50%;\r\n    box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.7) inset;\r\n    display: block;\r\n    height: 12px;\r\n    transition: box-shadow 0.3s ease 0s;\r\n    width: 12px;\r\n}\r\n\r\n.lg-outer .lg-pager:hover, .lg-outer .lg-pager:focus { box-shadow: 0 0 0 8px white inset; }\r\n\r\n.lg-outer .lg-caret {\r\n    border-left: 10px solid transparent;\r\n    border-right: 10px solid transparent;\r\n    border-top: 10px dashed;\r\n    bottom: -10px;\r\n    display: inline-block;\r\n    height: 0;\r\n    left: 50%;\r\n    margin-left: -5px;\r\n    position: absolute;\r\n    vertical-align: middle;\r\n    width: 0;\r\n}\r\n\r\n.lg-fullscreen:after { content: \"\\e20c\"; }\r\n\r\n.lg-fullscreen-on .lg-fullscreen:after { content: \"\\e20d\"; }\r\n\r\n.group { *zoom: 1; }\r\n\r\n.group:before, .group:after {\r\n    content: \"\";\r\n    display: table;\r\n    line-height: 0;\r\n}\r\n\r\n.group:after { clear: both; }\r\n\r\n.lg-outer {\r\n    -o-transition: opacity 0.15s ease 0s;\r\n    -webkit-transition: opacity 0.15s ease 0s;\r\n    height: 100%;\r\n    left: 0;\r\n    opacity: 0;\r\n    position: fixed;\r\n    top: 0;\r\n    transition: opacity 0.15s ease 0s;\r\n    width: 100%;\r\n    z-index: 1050;\r\n}\r\n\r\n.lg-outer * {\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.lg-outer.lg-visible { opacity: 1; }\r\n\r\n.lg-outer.lg-css3 .lg-item.lg-prev-slide, .lg-outer.lg-css3 .lg-item.lg-next-slide, .lg-outer.lg-css3 .lg-item.lg-current {\r\n    -webkit-transition-duration: inherit !important;\r\n    -webkit-transition-timing-function: inherit !important;\r\n    transition-duration: inherit !important;\r\n    transition-timing-function: inherit !important;\r\n}\r\n\r\n.lg-outer.lg-css3.lg-dragging .lg-item.lg-prev-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-next-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-current {\r\n    -webkit-transition-duration: 0s !important;\r\n    opacity: 1;\r\n    transition-duration: 0s !important;\r\n}\r\n\r\n.lg-outer.lg-grab img.lg-object {\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n    cursor: -o-grab;\r\n    cursor: -ms-grab;\r\n    cursor: grab;\r\n}\r\n\r\n.lg-outer.lg-grabbing img.lg-object {\r\n    cursor: move;\r\n    cursor: -webkit-grabbing;\r\n    cursor: -moz-grabbing;\r\n    cursor: -o-grabbing;\r\n    cursor: -ms-grabbing;\r\n    cursor: grabbing;\r\n}\r\n\r\n.lg-outer .lg {\r\n    height: 100%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer .lg-inner {\r\n    height: 100%;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    white-space: nowrap;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer .lg-item {\r\n    background: url(\"../img/loading.gif\") no-repeat scroll center center transparent;\r\n    display: none !important;\r\n}\r\n\r\n.lg-outer.lg-css3 .lg-prev-slide, .lg-outer.lg-css3 .lg-current, .lg-outer.lg-css3 .lg-next-slide { display: inline-block !important; }\r\n\r\n.lg-outer.lg-css .lg-current { display: inline-block !important; }\r\n\r\n.lg-outer .lg-item, .lg-outer .lg-img-wrap {\r\n    display: inline-block;\r\n    height: 100%;\r\n    position: absolute;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.lg-outer .lg-item:before, .lg-outer .lg-img-wrap:before {\r\n    content: \"\";\r\n    display: inline-block;\r\n    height: 50%;\r\n    margin-right: -1px;\r\n    width: 1px;\r\n}\r\n\r\n.lg-outer .lg-img-wrap {\r\n    padding: 0 5px;\r\n    position: static;\r\n}\r\n\r\n.lg-outer .lg-item.lg-complete { background-image: none; }\r\n\r\n.lg-outer .lg-item.lg-current { z-index: 1060; }\r\n\r\n.lg-outer .lg-image {\r\n    display: inline-block;\r\n    height: auto !important;\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n    vertical-align: middle;\r\n    width: auto !important;\r\n}\r\n\r\n.lg-outer.lg-show-after-load .lg-item .lg-object, .lg-outer.lg-show-after-load .lg-item .lg-video-play {\r\n    -o-transition: opacity 0.15s ease 0s;\r\n    -webkit-transition: opacity 0.15s ease 0s;\r\n    opacity: 0;\r\n    transition: opacity 0.15s ease 0s;\r\n}\r\n\r\n.lg-outer.lg-show-after-load .lg-item.lg-complete .lg-object, .lg-outer.lg-show-after-load .lg-item.lg-complete .lg-video-play { opacity: 1; }\r\n\r\n.lg-outer .lg-empty-html { display: none; }\r\n\r\n.lg-outer.lg-hide-download #lg-download { display: none; }\r\n\r\n.lg-backdrop {\r\n    -o-transition: opacity 0.15s ease 0s;\r\n    -webkit-transition: opacity 0.15s ease 0s;\r\n    background-color: #000;\r\n    bottom: 0;\r\n    left: 0;\r\n    opacity: 0;\r\n    position: fixed;\r\n    right: 0;\r\n    top: 0;\r\n    transition: opacity 0.15s ease 0s;\r\n    z-index: 1040;\r\n}\r\n\r\n.lg-backdrop.in { opacity: 0.7; }\r\n\r\n.lg-css3.lg-no-trans .lg-prev-slide, .lg-css3.lg-no-trans .lg-next-slide, .lg-css3.lg-no-trans .lg-current {\r\n    -moz-transition: none 0s ease 0s !important;\r\n    -o-transition: none 0s ease 0s !important;\r\n    -webkit-transition: none 0s ease 0s !important;\r\n    transition: none 0s ease 0s !important;\r\n}\r\n\r\n.lg-css3.lg-use-css3 .lg-item {\r\n    -moz-backface-visibility: hidden;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n}\r\n\r\n.lg-css3.lg-use-left .lg-item {\r\n    -moz-backface-visibility: hidden;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n}\r\n\r\n.lg-css3.lg-fade .lg-item { opacity: 0; }\r\n\r\n.lg-css3.lg-fade .lg-item.lg-current { opacity: 1; }\r\n\r\n.lg-css3.lg-fade .lg-item.lg-prev-slide, .lg-css3.lg-fade .lg-item.lg-next-slide, .lg-css3.lg-fade .lg-item.lg-current {\r\n    -moz-transition: opacity 0.1s ease 0s;\r\n    -o-transition: opacity 0.1s ease 0s;\r\n    -webkit-transition: opacity 0.1s ease 0s;\r\n    transition: opacity 0.1s ease 0s;\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-css3 .lg-item { opacity: 0; }\r\n\r\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide {\r\n    -webkit-transform: translate3d(-100%, 0, 0);\r\n    transform: translate3d(-100%, 0, 0);\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide {\r\n    -webkit-transform: translate3d(100%, 0, 0);\r\n    transform: translate3d(100%, 0, 0);\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {\r\n    -moz-transition: -moz-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n    -o-transition: -o-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n    -webkit-transition: -webkit-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n    transition: transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-left .lg-item {\r\n    left: 0;\r\n    opacity: 0;\r\n    position: absolute;\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide { left: -100%; }\r\n\r\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide { left: 100%; }\r\n\r\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-current {\r\n    left: 0;\r\n    opacity: 1;\r\n}\r\n\r\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-current {\r\n    -moz-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n    -o-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n    -webkit-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n    transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\r\n}\r\n\r\n/*# sourceMappingURL=lightgallery.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
